import React from 'react';
import { PDPDiscussionData } from '../../../Utils/productPageUtils';
import CategoryPageFaqsData from '../../CategoryDetail/CategoryPageFaqsData';
import { BlackReviewTitle } from '../../Product/RatingandReviews/styled';

function ProductPageFaqs(props) {
  const { productData } = props;
  const faqsData = PDPDiscussionData[productData?.id] || null;
  if (!faqsData) return <></>;
  return (
    <>
      <BlackReviewTitle seperate={true}>FAQs</BlackReviewTitle>
      <CategoryPageFaqsData
        faqsData={PDPDiscussionData[productData?.id]}
        hideHeading={true}
        productData={productData}
      />
    </>
  );
}

export default ProductPageFaqs;
